import React from "react";
import './styles.css';

export const Switcher = ({ checked, onChange, className, label, disabled }) => {
    const handleClick = () => {
        if (!disabled) {
            onChange(!checked);
        }
    };

    return (
        <div
            className={
                "switcher_container " +
                (className ? className : "") +
                (disabled ? " switcher_disabled" : "")
            }
            onClick={handleClick}
        >
            <div className={
                "switcher_toggle" +
                (checked ? " switcher_toggle-checked" : "") +
                (disabled ? " switcher_toggle-disabled" : "")
            }>
                <div className="switcher_circle" />
            </div>
            <div className="switcher_label">
                {label}
            </div>
        </div>
    );
};

